import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export default function AreYouSureDialog({
  isOpen,
  handleClose,
  handleClickActionButton,
  title,
  message,
  actionButtonText,
}) {
  return (
    <div>
      <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Typography>{message}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleClickActionButton} variant="contained">
            {actionButtonText}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
